import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PatientsServices {
    constructor(private httpClient: HttpClient
    ) {
    }

    searchPatient(searchPattern: string): Observable<Array<any>> {
        return this.httpClient
            .get(`servlets/patients/search/?pattern=${searchPattern}`, {observe: 'body'})
            .pipe(
                map((response: any) => response.persons)
            );
    }

    getPatient(patientId: number): Observable<Array<any>> {
        return this.httpClient
            .get(`servlets/patients/${patientId}/`, {observe: 'body'})
            .pipe(
                map((response: any) => response.person)
            );
    }

    setPatientStrategy(personId: number, strategyId: number, estimated: boolean): Observable<any> {
        console.debug(`setting strategy (${strategyId}) for patient ${personId}`);

        return this.httpClient
            .post(`servlets/patients/${personId}/`, {strategyId: strategyId, estimated});
    }

    getPatientByRemoteId(remotePersonId: string): Observable<Array<any>> {
        return this.httpClient
            .get(`servlets/patients/remoteid/${remotePersonId}/`, {observe: 'body'})
            .pipe(
                map((response: any) => response.person)
            );
    }

    searchPatientByPetName(searchPattern: string): Observable<Array<any>> {
        return this.httpClient
            .get(`servlets/patients/search/pets/?pattern=${searchPattern}`, {observe: 'body'})
            .pipe(
                map((response: any) => response.persons)
            );
    }


}
